import ConnectorSelector from '@avalara/bat-apps-shared/client/components/connectors/connector-selector';
import { FEATURED_CONNECTORS, SOHO_CONNECTORS } from '@avalara/bat-apps-shared/constants';
import { generateGridView } from '@avalara/bat-apps-shared/helpers/connector-selector';

import { t } from '@avalara/bat-apps-shared/i18n';
import type { Connector } from '@avalara/types/index';

import { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import conf from '../../../conf';

import type { Props } from '../../../containers/shared/connectors/select-connector';
import analytics from '../../../lib/analytics';
import { selectState } from '../../../selectors';
import { deselectConnector, searchConnectors, showConnectorDetails } from '../../../store/avatax-signup';
import { clearSelectedTier } from '../../../store/buy-flow';
import Banner from '../../banner';
import { getAPIConnectorDetails } from '../../helpers/connector-selector';

import { ConnectorSelectorContainer, ContentContainer, PageWrapper } from '../../styled/skylab/page';

const ConnectorView = (props: Props) => {
  const { isBannerHidden, onSelectConnector } = props;
  const dispatch = useDispatch();
  const state = useSelector(selectState);
  const history = useHistory();
  const {
    avataxSignup: {
      isSoho,
      partnerSignup,
      search: { connectorsSearchResults, connectorSearchString },
      selectedConnector,
    },
    data: {
      connectors: { data },
    },
    system: { activeFlow, isMobile },
  } = state;

  useEffect(() => {
    dispatch(clearSelectedTier());
  }, []);

  const connectorList = isSoho ? SOHO_CONNECTORS : FEATURED_CONNECTORS;
  return (
    <Fragment>
      {!isBannerHidden && (
        <Banner
          backgroundImage={`${conf.ASSET_PATH}/assets/images/banner-background.png`}
          image={`${conf.ASSET_PATH}/assets/images/connector_w.svg`}
          partnerSignup={partnerSignup}
          primaryText='Seamlessly connect'
          secondaryText={activeFlow === 'avatax-direct-buy' ? null : 'Start your free trial today'}
        />
      )}
      <PageWrapper isHolder={isBannerHidden}>
        <ConnectorSelectorContainer>
          <ContentContainer className='intro'>
            <p>
              {t(
                'client.general.find-an-existing-solution-to-integrate-avatax-with-your-company-accounting-software-or-connect-with-avalara-api',
              )}
            </p>
          </ContentContainer>
          <ConnectorSelector
            {...props}
            analytics={analytics}
            avataxLink={conf.CUP_URL}
            connectors={data}
            fallbackImg={`${conf.ASSET_PATH}/assets/images/empty.png`}
            gridView={generateGridView(data, connectorList)}
            inIntegrations={false}
            isEligibleToBuy={true}
            isMobile={isMobile}
            isSoho={isSoho}
            myConnectors={[]}
            onShowConnectorDetails={(selectConnector: Connector) => dispatch(showConnectorDetails(selectConnector))}
            onDeselectConnector={() => dispatch(deselectConnector())}
            onSearchConnectors={(results: Array<Connector>, searchString: string) =>
              dispatch(searchConnectors({ connectorsSearchResults: results, connectorSearchString: searchString }))
            }
            searchConnectorsResults={connectorsSearchResults}
            searchString={connectorSearchString}
            selectedConnector={selectedConnector}
          />

          {!isSoho && (
            <ContentContainer>
              <button
                type='button'
                title='API'
                className='api-select-link link api-button'
                onClick={() =>
                  dispatch(showConnectorDetails(getAPIConnectorDetails(data))) && onSelectConnector(history)
                }
              >
                {t('client.buttons.build-your-own-integration-with-avalara-api-in-our-sandbox-environment')}
              </button>
            </ContentContainer>
          )}
        </ConnectorSelectorContainer>
      </PageWrapper>
    </Fragment>
  );
};

export default ConnectorView;
